import { isValid, parseISO } from 'date-fns'

/**
 * Parse an appointment date value — either a bare `YYYY-MM-DD` calendar date
 * or a full ISO timestamp — into a local Date.
 *
 * Bare dates are constructed at local midnight to avoid the TZ roll-back a
 * naive `new Date('YYYY-MM-DD')` introduces (UTC midnight displays as the
 * previous day west of UTC). `parseISO` + `isValid` also reject overflow
 * strings like `2026-02-30` that `new Date()` would silently roll forward
 * onto a real day — for a bad EHR export, a dropped value beats a wrong one.
 */
export function parseAppointmentDate(value: string | null): Date | null {
  if (!value) return null
  const date = parseISO(value.includes('T') ? value : `${value}T00:00:00`)
  return isValid(date) ? date : null
}
